<template>
    <div>
        <vue-element-loading :active="isSubmit" />
        <v-card>
            <v-card-title>
                <v-icon color="primary">
                    {{ getIcon(userType) }}
                </v-icon>
                <span class="pl-2">
                    {{ 
                    userType === 'students' 
                        ? $t('account') 
                        : (userType === 'admin-drivers' 
                            ? $t('drivers') 
                            : capitalizeFirstLetter($t(userType)))
                    }}
                </span>
                <v-spacer></v-spacer>
                <create-button v-if="userType === 'schools'" @create="showCreateSchoolDialog"></create-button>
                <create-button v-if="userType === 'drivers' || userType === 'admin-drivers'" @create="showCreateDriverDialog"></create-button>
                <create-button v-else-if="userType === 'guardians'" @create="showCreateParentDialog"></create-button>
                <div v-else-if="userType === 'students'">
                    <create-button @create="showCreateStudentDialog"></create-button>
                    <v-btn class="mr-2" color="info" @click="downloadTemplate" :disabled="isSubmit">
                        <v-icon class="me-2">mdi-file-download</v-icon>
                        <span> {{$t('download_xlsx_template')}}</span>
                    </v-btn>
                    <v-btn color="primary" @click="openUploadFile" :disabled="isSubmit">
                        <v-icon class="me-2">mdi-file-upload</v-icon>
                        <span>{{$t('upload_xlsx_template')}}</span>
                    </v-btn>
                    <input type="file" id="file" ref="file" style="display: none" accept=".xlsx"
                        @change="uploadTemplateFile" />
                </div>
            </v-card-title>
            <v-tabs v-model="active_tab" show-arrows class="my-2">
                <v-tab v-for="tab in tabs" :key="tab.idx">
                    <v-icon size="20" class="me-3">
                        {{ tab.icon }}
                    </v-icon>
                    <span>{{ tab.title }}</span>
                </v-tab>
            </v-tabs>
            <!-- tabs item -->
            <v-tabs-items v-model="active_tab">
                <!-- active -->
                <v-tab-item>
                    <users-table :users="activeUsers" :userType="userType" :tab="active_tab" :mode="mode"
                        @view-user="viewUser" @edit-user="editUser" @suspend-user="suspendActivateUser"
                        @unassign-bus="unAssignBus" @assign-bus="assignBus" @set-student-bus="setStudentBus"
                        @login-as-school="loginAsSchool" @delete-school="deleteSchool"
                        @show-student-location="showStudentLocation"></users-table>
                </v-tab-item>

                <!-- suspended -->
                <v-tab-item>
                    <users-table :users="suspendedUsers" :userType="userType" :tab="active_tab" :mode="mode"
                        @view-user="viewUser" @edit-user="editUser" @suspend-user="suspendActivateUser"
                        @unassign-bus="unAssignBus" @assign-bus="assignBus" @login-as-school="loginAsSchool"
                        @delete-school="deleteSchool"></users-table>
                </v-tab-item>

                <v-tab-item>
                    <users-table v-if="userType === 'drivers' || userType === 'students' || userType === 'admin-drivers'" :users="underReviewUsers"
                        :mode="mode" :userType="userType" :tab="active_tab" @view-user="viewUser"></users-table>
                </v-tab-item>

                <v-tab-item>
                    <users-table v-if="userType === 'students'" :users="outOfCoinsUsers" :mode="mode"
                        :userType="userType" :tab="active_tab" @view-user="viewUser"></users-table>
                </v-tab-item>
            </v-tabs-items>
        </v-card>
        <v-dialog v-if="selectedDriver" v-model="busesDialog" max-width="390">
            <v-card>
                <v-card-title class="text-h5">
                    Select vehicle for '{{ selectedDriver.name }}'
                </v-card-title>

                <v-card-text>
                    <v-list dense>
                        <v-subheader>Vehicles</v-subheader>
                        <v-list-item-group>
                            <v-list-item v-for="(bus, i) in availableBuses" :key="i">
                                <v-list-item-content @click="assignBusToDriver(bus)">
                                    <v-list-item-title v-text="'License: ' + bus.license"></v-list-item-title>
                                    <v-list-item-subtitle v-text="'Capacity: ' + bus.capacity"></v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-card-text>
                <v-container style="height: 400px">
                    <v-row v-show="loadingBuses" class="fill-height" align-content="center" justify="center">
                        <v-col class="text-subtitle-1 text-center" cols="12">
                            Please wait ...
                        </v-col>
                        <v-col cols="6">
                            <v-progress-linear :active="loadingBuses" color="primary" indeterminate rounded
                                height="6"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="green darken-1" text @click="closeBusDialog">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-if="selectedStudent" v-model="busesForStudentDialog" max-width="490">
            <v-card>
                <v-card-title class="text-h5">
                    Select {{ selectedStudentMorning == 1 ? 'morning' : 'afternoon' }}
                    vehicle for '{{ selectedStudent.name }}'
                </v-card-title>

                <v-card-text>
                    <v-list dense>
                        <v-subheader>Vehicles</v-subheader>
                        <v-list-item-group>
                            <v-list-item v-for="(bus, i) in availableBuses" :key="i">
                                <v-list-item-content @click="assignBusToStudent(bus)">
                                    <v-list-item-title v-text="'License: ' + bus.license"></v-list-item-title>
                                    <v-list-item-subtitle v-text="'Capacity: ' + bus.capacity"></v-list-item-subtitle>
                                    <v-list-item-subtitle
                                        v-text="'Available seats: ' + bus.available_seats"></v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-card-text>
                <v-container style="height: 400px">
                    <v-row v-show="loadingBuses" class="fill-height" align-content="center" justify="center">
                        <v-col class="text-subtitle-1 text-center" cols="12">
                            Please wait ...
                        </v-col>
                        <v-col cols="6">
                            <v-progress-linear :active="loadingBuses" color="primary" indeterminate rounded
                                height="6"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="green darken-1" text @click="closeStudentBusDialog">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-row justify="center">
            <v-dialog v-model="schoolDialog" persistent max-width="700px">
                <v-form ref="form" v-model="valid" lazy-validation>
                    <v-card>
                        <v-card-title>
                            <span class="text-h5">Facility Manager</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field v-model="name" :rules="nameRules" label="Name*"
                                        hint="name of the manager" required></v-text-field>
                                </v-col>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="password" :rules="passRules" label="Password*"
                                            hint="Password of the manager account" type="password"
                                            required></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="confirmPassword" :rules="confirmPassRules"
                                            label="Confirm Password*" hint="Password of the manager account"
                                            type="password" required></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="email" :rules="emailRules" label="Email*"
                                            hint="Email of the student account" type="email" required></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="confirmEmail" :rules="confirmEmailRules"
                                            label="Confirm Email*" hint="Email of the manager account"
                                            type="email" required></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-select v-model="region" :items="regions" :rules="[value => !!value || 'Required']" item-text="region_en" item-value="region_en" label="Region*" @change="onRegionChange"
                                            hint="Select your region"></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-select v-model="city" :items="cities" :rules="[value => !!value || 'Required']" item-text="en" item-value="en" label="City*" :disabled="!region"
                                            hint="Select your city"></v-select>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-title>
                            <span class="text-h5">Facility Data</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="facility_name" :rules="facilityNameRules"
                                            label="Facility Name*" hint="name of the facility"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="address" :rules="addressRules" label="Address*"
                                            hint="Address of the manager account"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="zipcode" :rules="zipCodeRules" label="Zip Code*"
                                            hint="Zip Code of the facility" type="text"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="mobile_number" :rules="mobileNumberRules"
                                            label="Phone Number*" hint="Phone Number of the facility" type="text"
                                            required></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="fax" :rules="faxRules" label="Fax*"
                                            hint="Fax of the Facility" type="text"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="mailbox" :rules="mailBoxRules" label="Mailbox*"
                                            hint="Mailbox of the Facility" type="text"></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-title>
                            <span class="text-h5">Establishment data</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="commercialRegistrationNumber"
                                            :rules="commercialRegistrationNumberRules"
                                            type="number"
                                            label="Commercial Registration Number*"
                                            hint="commercial registration number of the facility"
                                            ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="expiryDate" :rules="[value => !!value || 'Required']" label="Expiry Date*"
                                            hint="Expiry date of the facility" type="date"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-select v-model="idType" :rules="[value => !!value || 'Required']" :items="idTypes"
                                            label="ID Type*" hint="Select your ID Type"></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="idNumber" :rules="idNumberRules" label="ID Number*"
                                            hint="ID Number" type="number"></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-title>
                            <span class="text-h5">Data & Licenses</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="educationalTransportOperationCardNumber"
                                            :rules="educationalTransportOperationCardNumberRules"
                                            label="Educational Transport Operation Card Number*"
                                            type="number"
                                            hint="Educational Transport Operation Card Number"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="educationalTransportOperatingCardExpiryDate" :rules="[value => !!value || 'Required']"
                                            label="Educational Transport Operating Card Expiry Date*"
                                            hint="Educational Transport Operating Card Expiry Date"
                                            type="date"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-col cols="12" sm="6" md="6">
                                    <v-checkbox v-model="termsConditions" :rules="termsConditionsRules"
                                        label="Terms & Conditions*" hint="Terms & Conditions" required></v-checkbox>
                                </v-col>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="schoolDialog = false">
                                Close
                            </v-btn>
                            <v-btn color="blue darken-1" text @click="createSchool">
                                Save
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
            <v-dialog v-model="studentDialog" persistent max-width="700px">
                <v-form ref="form" v-model="valid" lazy-validation>
                    <v-card>
                        <v-card-title>
                            <span class="text-h5">Account</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="name" :rules="nameRules" label="Name*"
                                            hint="name of the student" required></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="mobile_number" :rules="mobileNumberRules"
                                            label="Phone Number*" hint="Phone Number of the student account"
                                            required></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="password" :rules="passRules" label="Password*"
                                            hint="Password of the student account" type="password"
                                            required></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="confirmPassword" :rules="confirmPassRules"
                                            label="Confirm Password*" hint="Password of the student account"
                                            type="password" required></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="email" :rules="emailRules" label="Email*"
                                            hint="Email of the student account" type="email" required></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="confirmEmail" :rules="confirmEmailRules"
                                            label="Confirm Email*" hint="Email of the student account" type="email"
                                            required></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-select v-model="selectParent" :rules="selectParentRules" :items="allParents" label="Select Guardian*"
                                            hint="Select Student Guardian*" required item-text="name"
                                            item-value="id"></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-select v-model="selectSchool" :rules="selectSchoolRules" :items="allSchools" label="Select Facility*"
                                            hint="Select Passenger*" required item-text="name"
                                            item-value="id"></v-select>
                                    </v-col>

                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-select v-model="city" :rules="[value => !!value || 'Required']" :items="cities" item-text="en" item-value="en" label="City*" :disabled="!region"
                                            hint="Select your city"></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-select v-model="region" :rules="[value => !!value || 'Required']" :items="regions" item-text="region_en" item-value="region_en" label="Region*" @change="onRegionChange"
                                            hint="Select your region"></v-select>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="address" :rules="addressRules" label="Address*"
                                            hint="Address of the student account" type="text"></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="studentDialog = false">
                                Close
                            </v-btn>
                            <v-btn color="blue darken-1" text @click="createStudent">
                                Save
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
            <v-dialog v-model="parentDialog" persistent max-width="700px">
                <v-form ref="form" v-model="valid" lazy-validation>
                    <v-card>
                        <v-card-title>
                            <span class="text-h5">Guardian account</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="name" :rules="nameRules" label="Name*"
                                            hint="name of the guardian" required></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="mobile_number" :rules="mobileNumberRules"
                                            label="Phone Number*" hint="Phone Number of the student account"
                                            required></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="password" :rules="passRules" label="Password*"
                                            hint="Password of the guardian account" type="password"
                                            required></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="confirmPassword" :rules="confirmPassRules"
                                            label="Confirm Password*" hint="Password of the guardian account"
                                            type="password" required></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="email" :rules="emailRules" label="Email*"
                                            hint="Email of the guardian account" type="email" required></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="confirmEmail" :rules="confirmEmailRules"
                                            label="Confirm Email*" hint="Email of the guardian account" type="email"
                                            required></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-select v-model="region" :items="regions" :rules="[value => !!value || 'Required']" item-text="region_en" item-value="region_en" label="Region*" @change="onRegionChange"
                                            hint="Select your region"></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-select v-model="city" :items="cities" :rules="[value => !!value || 'Required']" item-text="en" item-value="en" label="City*" :disabled="!region"
                                            hint="Select your city"></v-select>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="address" :rules="addressRules" label="Address*"
                                            hint="Address of the guardian account" type="text"></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="parentDialog = false">
                                Close
                            </v-btn>
                            <v-btn color="blue darken-1" text @click="createParent">
                                Save
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
            <v-dialog v-model="driverDialog" persistent max-width="700px">
                <v-form ref="form" v-model="valid" lazy-validation>
                    <v-card>
                        <v-card-title>
                            <span class="text-h5">Driver account</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="name" :rules="nameRules" label="Name*"
                                            hint="name of the guardian" required></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="mobile_number" :rules="mobileNumberRules"
                                            label="Phone Number*" hint="Phone Number of the student account"
                                            required></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="password" :rules="passRules" label="Password*"
                                            hint="Password of the guardian account" type="password"
                                            required></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="confirmPassword" :rules="confirmPassRules"
                                            label="Confirm Password*" hint="Password of the guardian account"
                                            type="password" required></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="email" :rules="emailRules" label="Email*"
                                            hint="Email of the guardian account" type="email" required></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="confirmEmail" :rules="confirmEmailRules"
                                            label="Confirm Email*" hint="Email of the guardian account" type="email"
                                            required></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-select v-model="region" :items="regions" :rules="[value => !!value || 'Required']" item-text="region_en" item-value="region_en" label="Region*" @change="onRegionChange"
                                            hint="Select your region"></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-select v-model="city" :items="cities" :rules="[value => !!value || 'Required']" item-text="en" item-value="en" label="City*" :disabled="!region"
                                            hint="Select your city"></v-select>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-title>
                            <span class="text-h5">Driver Information</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="address" :rules="addressRules" label="Address*"
                                            hint="Address of the guardian account" type="text"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="driverLicenseNumber" :rules="[value => !!value || 'Required']" label="License Number*"
                                            hint="License Number" type="text"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="license_history" :rules="[value => !!value || 'Required']" label="License History*"
                                            hint="License History"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="educationalTransportOperationCardNumber" :rules="[value => !!value || 'Required']" label="Educational Transport Operation Card Number*"
                                            hint="Educational Transport Operation Card Number"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="driverLicenseExpiryDate" :rules="[value => !!value || 'Required']" label="Driver License Expiry Date*"
                                            hint="Driver License Expiry Date"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="vehicleRegistrationLicenseAttachment" :rules="[value => !!value || 'Required']" label="Vehicle Registration License Attachment*"
                                            hint="Vehicle Registration License Attachment"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="vehicleRegistrationExpiryDate" :rules="[value => !!value || 'Required']" label="Vehicle Registration Expiry Date*"
                                            hint="Vehicle Registration Expiry Date"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="isVehicleOwner" label="Is Vehicle Owner*" :rules="[value => !!value || 'Required']"
                                            hint="Is Vehicle Owner"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="VehicleOwnerName" label="Vehicle Owner Name*" :rules="[value => !!value || 'Required']"
                                            hint="Vehicle Owner Name"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="idOrCrNumber" label="Id Or Cr Number*" :rules="[value => !!value || 'Required']"
                                            hint="Id Or Cr Number"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="vehicleBrand" label="Vehicle Brand*" :rules="[value => !!value || 'Required']"
                                            hint="Vehicle Brand"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="vehicleModel" label="Vehicle Model*" :rules="[value => !!value || 'Required']"
                                            hint="Vehicle Model"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="vehicleColor" label="Vehicle Color*" :rules="[value => !!value || 'Required']"
                                            hint="Vehicle Color"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="yearOfManufacture" label="Year Of Manufacture*" :rules="[value => !!value || 'Required']"
                                            hint="Year Of Manufacture"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="plateNumber" label="Plate Number*" :rules="[value => !!value || 'Required']"
                                            hint="Plate Number"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="vin" label="Vin*" :rules="[value => !!value || 'Required']"
                                            hint="Vin"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-text-field v-model="vehicleOccupancy" label="Vehicle Occupancy*" :rules="[value => !!value || 'Required']"
                                            hint="Vehicle Occupancy"></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="driverDialog = false">
                                Close
                            </v-btn>
                            <v-btn color="blue darken-1" text @click="createDriver">
                                Save
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import usersTable from "./users-table.vue";
import {
    mdiAccountCheck,
    mdiAccountOff,
    mdiAirplane,
    mdiMotionPause,
    mdiAccountClock,
    mdiAccountQuestion,
} from "@mdi/js";

import VueElementLoading from "vue-element-loading";
import auth from "@/services/AuthService";
import CreateButton from "@/components/CreateButton";
import firebase from 'firebase/compat/app';
import regionData from "@/saudi_arabia_regions_and_cities_bilingual.json";
console.log(regionData)
export default {
    components: {
        VueElementLoading,
        usersTable,
        CreateButton
    },
    data() {
        return {
            mode: null,
            file: null,
            userType: "",
            users: [],
            activeUsers: [],
            suspendedUsers: [],
            underReviewUsers: [],
            outOfCoinsUsers: [],
            availableBuses: [],
            dialog: false,
            busesDialog: false,
            busesForStudentDialog: false,
            loadingBuses: false,
            isSubmit: false,
            isSubmit: false,
            selectedUser: null,
            selectedDriver: null,
            selectedStudent: null,
            selectedStudentMorning: null,
            tabs: [],
            driverTabs: [
                { idx: 0, title: this.$t('active'), icon: mdiAirplane },
                { idx: 1, title: this.$t('suspended'), icon: mdiMotionPause },
                { idx: 2, title: this.$t('under_review'), icon: mdiAccountClock },
            ],
            studentTabs: [
                { idx: 0, title: this.$t('active'), icon: mdiAirplane },
                { idx: 1, title: this.$t('suspended'), icon: mdiMotionPause },
                { idx: 2, title: this.$t('under_review'), icon: mdiAccountClock },
                { idx: 3, title: this.$t('out_of_coins'), icon: mdiAccountQuestion },
            ],
            defaultTabs: [
                { idx: 0, title: this.$t('active'), icon: mdiAirplane },
                { idx: 1, title: this.$t('suspended'), icon: mdiMotionPause },
            ],
            active_tab: null,
            name: "",
            nameRules: [
                (v) => !!v || "Name is required",
                (v) =>
                    (v && v.length <= 50) ||
                    "Name must be less than 50 characters",
            ],
            selectParent:"",
            allParents : [],
            selectParentRules:[
                (v) => !!v || "Parent is required",
            ],
            selectSchool:"",
            allSchools : [],
            selectSchoolRules:[
                (v) => !!v || "School is required",
            ],
            facility_name: "",
            facilityNameRules: [
                (v) =>
                    (v.length <= 50) ||
                    "Facility Name must be less than 50 characters",
                    (v) => !!v || "Name is required",
            ],
            region: "",
            regions: regionData.SaudiArabiaRegions,
            city: "",
            cities: [],
            idType: "",
            idTypes: ["National Identity", "Accommodation", "Passport"],
            idNumber: 0,
            idNumberRules: [
                (v) => /^\d+$/.test(v) || "must contain only digits",
                (v) => !!v || "Name is required",
            ],
            commercialRegistrationNumber: 0,
            commercialRegistrationNumberRules: [
                (v) => /^\d+$/.test(v) || "must contain only digits",
                (v) => !!v || "Name is required",
            ],
            expiryDate: "",
            educationalTransportOperatingCardExpiryDate: "",
            educationalTransportOperationCardNumber: 0,
            educationalTransportOperationCardNumberRules: [
                (v) => /^\d+$/.test(v) || "must contain only digits",
                (v) => !!v || "Name is required",
            ],
            termsConditions: "",
            termsConditionsRules: [
                (v) => !!v || "Required",
            ],
            address: "",
            addressRules: [
                (v) =>
                    (v.length <= 50) ||
                    "Address must be less than 50 characters",
                    (v) => !!v || "Required",
            ],
            zipcode: "",
            zipCodeRules: [
                (v) =>
                    (v.length <= 50) ||
                    "Zip Code must be less than 50 characters",
                    (v) => !!v || "Required",
            ],
            fax: "",
            faxRules: [
                (v) =>
                    (v.length <= 50) ||
                    "Fax be less than 50 characters",
                    (v) => !!v || "Required",
            ],
            mailbox: "",
            mailBoxRules: [
                (v) =>
                    (v.length <= 50) ||
                    "Mail Box must be less than 50 characters",
                    (v) => !!v || "Required",
            ],
            address_on_map: "",
            addressOnMapRules: [
                (v) =>
                    (v.length <= 50) ||
                    "Address On Map must be less than 50 characters",
            ],
            mobile_number: "",
            mobileNumberRules: [
                (v) => !!v || "Phone Number Is Required",
                (v) => /^\d+$/.test(v) || "Phone number must contain only digits",
                (v) => (v.length >= 10 && v.length <= 15) || "Phone number must be between 10 and 15 digits",
            ],
            email: "",
            emailRules: [
                (v) => !!v || "E-mail is required",
                (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
            ],
            confirmEmail: "",
            confirmEmailRules: [
                (v) => !!v || "Confirm E-mail is required",
                (v) => v === this.email || "E-mails must match",
            ],
            password: "",
            passRules: [
                (v) => !!v || "Password is required",
                (v) => v.length >= 6 || "Password must be at least 6 characters",
            ],
            confirmPassword: "",
            confirmPassRules: [
                (v) => !!v || "Confirm Password is required",
                (v) => v === this.password || "Passwords must match",
            ],
            driverLicenseNumber : "",
            driverLicenseNumberRules : [
                (v) =>
                        (v.length <= 50) ||
                        "Address On Map must be less than 50 characters",
                        (v) => !!v || "Required",
            ],
            driverLicenseExpiryDate : "",
            license_history: "",
            vehicleRegistrationLicenseAttachment : "",
            vehicleRegistrationExpiryDate : "",
            isVehicleOwner : "",
            VehicleOwnerName : "",
            idOrCrNumber : "",
            vehicleBrand : "",
            vehicleModel : "",
            vehicleColor : "",
            yearOfManufacture : "",
            plateNumber : "",
            vin : "",
            vehicleOccupancy : "",
            schoolDialog: false,
            driverDialog: false,
            studentDialog: false,
            parentDialog: false,
            valid: true,
        };
    },
    watch: {
        $route(to, from) {
            this.userType = to.name;
            this.updateTabs();
            if (this.userType === "drivers") {
                this.active_tab = parseInt(localStorage.tabIdxDrivers);
            } else if (this.userType === "students") {
                this.active_tab = parseInt(localStorage.tabIdxStudents);
            } else if (this.userType === "parents") {
                this.active_tab = parseInt(localStorage.tabIdxParents);
            } else if (this.userType === "schools") {
                this.active_tab = parseInt(localStorage.tabIdxSchools);
            }
            this.loadUsers();
        },
        active_tab: function (newVal, oldVal) {
            if (this.userType === "drivers") {
                localStorage.tabIdxDrivers = newVal;
            } else if (this.userType === "parents") {
                localStorage.tabIdxParents = newVal;
            } else if (this.userType === "students") {
                localStorage.tabIdxStudents = newVal;
            } else if (this.userType === "schools") {
                localStorage.tabIdxSchools = newVal;
            }
        },
    },
    mounted() {
        this.mode = auth.getMode()
        this.userType = this.$router.currentRoute.name;
        this.updateTabs();
        if (this.userType === "drivers") {
            this.active_tab = parseInt(localStorage.tabIdxDrivers);
        } else if (this.userType === "parents") {
            this.active_tab = parseInt(localStorage.tabIdxParents);
        } else if (this.userType === "students") {
            this.active_tab = parseInt(localStorage.tabIdxStudents);
        } else if (this.userType === "schools") {
            this.active_tab = parseInt(localStorage.tabIdxSchools);
        }

        this.loadUsers();
        this.loadParents();
        this.loadSchools();

        //load buses for drivers
        if (this.userType === "drivers") {
            this.loadAvailableBuses();
        }
    },
    methods: {
        onRegionChange(){
            this.city = ""; // reset city
                // Find cities of selected region
                const regionObj = this.regions.find(
                    (r) => r.region_en === this.region
                );
                this.cities = regionObj ? regionObj.cities : [];
        },
        validate() {
            return this.$refs.form.validate();
        },
        async createSchool() {
            if (this.validate()) {
                this.error = null;
                try {
                    this.isSubmit = true;
                    var result = await firebase.auth().createUserWithEmailAndPassword(this.email, this.password);
                    var token = await result.user.getIdToken(true);
                    var response = await axios.post('/auth/loginViaToken', {
                        'device_name': `${vm.$browserDetect.meta.name}- v${vm.$browserDetect.meta.version}`,
                        token,
                        'role': 2,
                        'name': this.name,
                        'email': this.email,
                        'address': this.address,
                        'mobile_number': this.mobile_number,
                        'address_on_map': this.address_on_map,
                        'region': this.region,
                        'city': this.city,
                        'facility_name' : this.facility_name,
                        'fax' : this.fax,
                        'mailbox' : this.mailbox,
                        'idType' : this.idType,
                        'idNumber' : this.idNumber,
                        'commercialRegistrationNumber' : this.commercialRegistrationNumber,
                        'expiryDate' : this.expiryDate,
                        'educationalTransportOperatingCardExpiryDate' : this.educationalTransportOperatingCardExpiryDate,
                        'educationalTransportOperationCardNumber' : this.educationalTransportOperationCardNumber,
                        'zipcode' : this.zipcode
                    });
                    this.users.push(response.data.user_data);
                    this.activeUsers = this.users.filter(
                        (user) => user.status_id === 1
                    );
                    this.suspendedUsers = this.users.filter(
                        (user) => user.status_id === 3
                    );
                    //add school to active users
                    // this.activeUsers.push(response.data.user_data);
                    this.$notify({
                        title: "Success",
                        text: "School created",
                        type: "success",
                    });
                    this.schoolDialog = false;
                    this.isSubmit = false;
                } catch (error) {
                    this.isSubmit = false;
                    this.$notify({
                        title: "Error",
                        text: error,
                        type: "error",
                    });
                    // this.$swal("Error", error.response.data.message, "error");
                }
            }
        },
        async createParent() {
            if (this.validate()) {
                this.error = null;
                try {
                    this.isSubmit = true;
                    var result = await firebase.auth().createUserWithEmailAndPassword(this.email, this.password);
                    var token = await result.user.getIdToken(true);
                    var response = await axios.post('/auth/loginViaToken', {
                        'device_name': `${vm.$browserDetect.meta.name}- v${vm.$browserDetect.meta.version}`,
                        token,
                        'role': 4,
                        'name': this.name,
                        'email': this.email,
                        'address': this.address,
                        'mobile_number': this.mobile_number,
                        'address_on_map': this.address_on_map,
                        'region': this.region,
                        'city': this.city
                    });
                    this.users.push(response.data.user_data);
                    this.activeUsers = this.users.filter(
                        (user) => user.status_id === 1
                    );
                    this.suspendedUsers = this.users.filter(
                        (user) => user.status_id === 3
                    );
                    //add school to active users
                    // this.activeUsers.push(response.data.user_data);
                    this.$notify({
                        title: "Success",
                        text: "School created",
                        type: "success",
                    });
                    this.schoolDialog = false;
                    this.isSubmit = false;
                } catch (error) {
                    this.isSubmit = false;
                    this.$notify({
                        title: "Error",
                        text: error,
                        type: "error",
                    });
                    // this.$swal("Error", error.response.data.message, "error");
                }
            }
        },
        async createStudent() {
            if (this.validate()) {
                this.error = null;
                try {
                    this.isSubmit = true;
                    var result = await firebase.auth().createUserWithEmailAndPassword(this.email, this.password);
                    var token = await result.user.getIdToken(true);
                    var response = await axios.post('/auth/loginViaToken', {
                        'device_name': `${vm.$browserDetect.meta.name}- v${vm.$browserDetect.meta.version}`,
                        token,
                        'role': 6,
                        'name': this.name,
                        'email': this.email,
                        'address': this.address,
                        'mobile_number': this.mobile_number,
                        'address_on_map': this.address_on_map,
                        'region': this.region,
                        'parent_id': this.selectParent,
                        'school_id': this.selectSchool,
                        'city': this.city
                    });
                    this.users.push(response.data.user_data);
                    this.activeUsers = this.users.filter(
                        (user) => user.status_id === 1
                    );
                    this.suspendedUsers = this.users.filter(
                        (user) => user.status_id === 3
                    );
                    //add school to active users
                    // this.activeUsers.push(response.data.user_data);
                    this.$notify({
                        title: "Success",
                        text: "Facility created",
                        type: "success",
                    });
                    this.schoolDialog = false;
                    this.isSubmit = false;
                } catch (error) {
                    this.isSubmit = false;
                    this.$notify({
                        title: "Error",
                        text: error,
                        type: "error",
                    });
                    // this.$swal("Error", error.response.data.message, "error");
                }
            }
        },
        async createDriver() {
            if (this.validate()) {
                this.error = null;
                try {
                    this.isSubmit = true;
                    var result = await firebase.auth().createUserWithEmailAndPassword(this.email, this.password);
                    var token = await result.user.getIdToken(true);
                    var personal_access_token = await localStorage.getItem('freshToken');
                    var response = await axios.post('/auth/loginViaToken', {
                        'device_name': `${vm.$browserDetect.meta.name}- v${vm.$browserDetect.meta.version}`,
                        token,
                        "personal_access_token" : personal_access_token,
                        'role': 3,
                        'name': this.name,
                        'email': this.email,
                        'address': this.address,
                        'mobile_number': this.mobile_number,
                        'address_on_map': this.address_on_map,
                        'region': this.region,
                        'city': this.city,
                        'license_number': this.driverLicenseNumber,
                        'license_history': this.license_history,
                        'educational_transport_operation_card_number': this.educationalTransportOperationCardNumber,
                        'educational_transport_operating_card_expiry_date': this.educationalTransportOperatingCardExpiryDate,
                        'driver_license_expiry_date': this.driverLicenseExpiryDate,
                        'vehicle_registration_license_attachment': this.vehicleRegistrationLicenseAttachment,
                        'vehicle_registration_expiry_date': this.vehicleRegistrationExpiryDate,
                        'is_vehicle_owner': this.isVehicleOwner,
                        'id_or_cr_number': this.idOrCrNumber,
                        'brand': this.vehicleBrand,
                        'vehicle_color': this.vehicleColor,
                        'model': this.vehicleModel,
                        'year_of_manufacture': this.yearOfManufacture,
                        'plate_number': this.plateNumber,
                        'vin': this.vin,
                        'vehicle_occupancy': this.vehicleOccupancy,
                    });
                    this.users.push(response.data.user_data);
                    this.activeUsers = this.users.filter(
                        (user) => user.status_id === 1
                    );
                    this.suspendedUsers = this.users.filter(
                        (user) => user.status_id === 3
                    );
                    //add school to active users
                    // this.activeUsers.push(response.data.user_data);
                    this.$notify({
                        title: "Success",
                        text: "Driver created",
                        type: "success",
                    });
                    this.schoolDialog = false;
                    this.isSubmit = false;
                } catch (error) {
                    this.isSubmit = false;
                    this.$notify({
                        title: "Error",
                        text: error,
                        type: "error",
                    });
                    // this.$swal("Error", error.response.data.message, "error");
                }
            }
        },
        showCreateSchoolDialog() {
            this.name = "";
            this.email = "";
            this.password = "";
            this.schoolDialog = true;
        },
        showCreateDriverDialog() {
            this.name = "";
            this.email = "";
            this.password = "";
            this.driverDialog = true;
        },
        showCreateStudentDialog() {
            this.name = "";
            this.email = "";
            this.password = "";
            this.studentDialog = true;
        },
        showCreateParentDialog() {
            this.name = "";
            this.email = "";
            this.password = "";
            this.parentDialog = true;
        },
        updateTabs() {
            if (this.userType === "drivers" || this.userType === "admin-drivers") {
                this.tabs = this.driverTabs;
            } else if (this.userType === "students") {
                this.tabs = this.studentTabs;
            } else {
                this.tabs = this.defaultTabs;
            }
        },
        capitalizeFirstLetter(string) {
            if (string == "schools") {
                return "Facility Manager";
            } else {
                return string.charAt(0).toUpperCase() + string.slice(1);
            }
        },
        getIcon(userType) {
            switch (userType) {
                case "schools":
                    return "mdi-school";
                case "students":
                    return "mdi-badge-account-outline";
                case "drivers":
                    return "mdi-account-tie-hat";
                case "guardians":
                    return "mdi-account-group-outline";
                default:
                    break;
            }
        },
        loadUsers() {
            this.isSubmit = true;
            let url = "/users/all-" + this.userType;
            this.users = [];
            axios
                .get(url)
                .then((response) => {
                    this.users = response.data;
                    this.activeUsers = this.users.filter(
                        (user) => user.status_id === 1
                    );
                    this.suspendedUsers = this.users.filter(
                        (user) => user.status_id === 3
                    );
                    this.underReviewUsers = this.users.filter(
                        (user) => user.status_id === 4
                    );
                    this.outOfCoinsUsers = this.users.filter(
                        (user) => user.status_id === 5
                    );
                })
                .catch((error) => {
                    this.$notify({
                        title: "Error",
                        text: error,
                        type: "error",
                    });
                    // auth.checkError(error.response.data.message, this.$router, this.$swal);
                })
                .then(() => {
                    this.isSubmit = false;
                });
        },
        loadParents() {
            this.isSubmit = true;
            let url = "/custom/get-all-parents";
            this.users = [];
            axios
                .get(url)
                .then((response) => {
                    this.allParents = response.data;
                })
                .catch((error) => {
                    this.$notify({
                        title: "Error",
                        text: error,
                        type: "error",
                    });
                    // auth.checkError(error.response.data.message, this.$router, this.$swal);
                })
                .then(() => {
                    this.isSubmit = false;
                });
        },
        loadSchools() {
            this.isSubmit = true;
            let url = "/custom/get-all-schools";
            this.users = [];
            axios
                .get(url)
                .then((response) => {
                    this.allSchools = response.data;
                })
                .catch((error) => {
                    this.$notify({
                        title: "Error",
                        text: error,
                        type: "error",
                    });
                    // auth.checkError(error.response.data.message, this.$router, this.$swal);
                })
                .then(() => {
                    this.isSubmit = false;
                });
        },
        deleteSchool(school) {

            this.$swal
                .fire({
                    title: "Delete School",
                    text:
                        "Are you sure to delete the account of '" +
                        school.name +
                        "' ?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete",
                    confirmButtonColor: "#f44336",
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.deleteSchoolServer(school);
                    }
                });
        },
        deleteSchoolServer(school) {
            this.isSubmit = true;
            axios
                .delete("/users/delete-school", {
                    data: {
                        school_id: school.id,
                    },
                })
                .then((response) => {
                    this.isSubmit = false;
                    this.$notify({
                        title: "Success",
                        text: "School deleted",
                        type: "success",
                    });
                    this.users = this.users.filter((user) => user.id !== school.id);
                    this.activeUsers = this.users.filter(
                        (user) => user.status_id === 1
                    );
                    this.suspendedUsers = this.users.filter(
                        (user) => user.status_id === 3
                    );
                })
                .catch((error) => {
                    this.isSubmit = false;
                    this.$notify({
                        title: "Error",
                        text: error,
                        type: "error",
                    });
                    // this.$swal("Error", error.response.data.message, "error");
                });
        },
        loginAsSchool(school) {

            this.$swal
                .fire({
                    title: "Login as School",
                    text:
                        "Are you sure to login as '" +
                        school.name +
                        "' ?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes, login",
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.loginAsSchoolServer(school);
                    }
                });
        },
        loginAsSchoolServer(school) {
            //post to backend login-from-admin-to-school
            this.isSubmit = true;
            axios
                .post("/auth/login-from-admin-to-school", {
                    school_id: school.id,
                    device_name: `${vm.$browserDetect.meta.name}- v${vm.$browserDetect.meta.version}`
                })
                .then((response) => {
                    this.isSubmit = false;
                    this.$notify({
                        title: "Success",
                        text: "Logged in as " + school.name,
                        type: "success",
                    });
                    const ourToken = response.data.token
                    let user = response.data.user_data
                    const userRole = user.role_id
                    const simple_mode = response.data.simple_mode
                    const freshToken = ourToken.split('|')[1]
                    localStorage.setItem('freshToken', freshToken)
                    localStorage.setItem('userRole', userRole)
                    localStorage.setItem('simple_mode', simple_mode)
                    axios.defaults.headers.common['Authorization'] = `Bearer ${freshToken}`
                    //redirect to school dashboard
                    this.$router.push({
                        name: "school-dashboard",
                    });
                })
                .catch((error) => {
                    this.isSubmit = false;
                    this.$notify({
                        title: "Error",
                        text: error,
                        type: "error",
                    });
                    console.log(error);
                    // this.$swal("Error", error.response.data.message, "error");
                });
        },
        viewUser(user) {
            let userType = this.userType.slice(0, -1);
            let routeName = "view-" + userType;
            this.$router.push({
                name: routeName,
                params: {
                    user_id: user.id,
                },
            });
        },
        showStudentLocation(student) {
            this.$router.push({
                name: "student-location",
                params: {
                    student_id: student.id,
                },
            });
        },
        editUser(user) {
            let userType = this.userType.slice(0, -1);
            let routeName = "edit-" + userType;
            this.$router.push({
                name: routeName,
                params: {
                    user_id: user.id,
                },
            });
        },
        suspendActivateUser(user, index) {
            //remove (s) from userType
            let userType = this.userType.slice(0, -1);
            this.$swal
                .fire({
                    title:
                        (user.status_id != 1 ? "Activate" : "Suspend") +
                        " " +
                        userType,
                    text:
                        "Are you sure to " +
                        (user.status_id != 1 ? "activate" : "suspend") +
                        " '" +
                        user.name +
                        "' ?",
                    icon: user.status_id != 1 ? "success" : "error",
                    showCancelButton: true,
                    confirmButtonText: "Yes",
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.suspendActivateUserServer(user, index);
                    }
                });
        },
        suspendActivateUserServer(user, indexx) {
            this.isSubmit = true;
            axios
                .post("/users/suspend-activate", {
                    user_id: user.id,
                })
                .then((response) => {
                    this.isSubmit = false;
                    //get the index
                    let index = this.users.indexOf(user);
                    this.users[index].status_id = user.status_id != 1 ? 1 : 3;
                    this.activeUsers = this.users.filter(
                        (user) => user.status_id === 1
                    );
                    this.suspendedUsers = this.users.filter(
                        (user) => user.status_id === 3
                    );
                    this.$notify({
                        title: "Success",
                        text:
                            "User " +
                            (user.status_id != 1 ? "suspended" : "activated"),
                        type: "success",
                    });
                })
                .catch((error) => {
                    this.isSubmit = false;
                    this.$notify({
                        title: "Error",
                        text: error,
                        type: "error",
                    });
                    // this.$swal("Error", error.response.data.message, "error");
                });
        },
        loadAvailableBuses() {
            this.loadingBuses = true;
            this.availableBuses = [];
            axios
                .get("/drivers/available-buses")
                .then((response) => {
                    this.availableBuses = response.data;
                })
                .catch((error) => {
                    this.$notify({
                        title: "Error",
                        text: error,
                        type: "error",
                    });
                    // this.$swal("Error", error.response.data.message, "error");
                })
                .then(() => {
                    this.loadingBuses = false;
                });
        },
        loadAllBuses(is_morning) {
            this.loadingBuses = true;
            this.availableBuses = [];
            axios
                .get("/drivers/all-buses")
                .then((response) => {
                    this.availableBuses = response.data;
                    if (is_morning == 1) {
                        //add available seats to the buses
                        this.availableBuses.forEach(bus => {
                            bus.available_seats = bus.available_morning_seats;
                        });
                    }
                    else {
                        //add available seats to the buses
                        this.availableBuses.forEach(bus => {
                            bus.available_seats = bus.available_afternoon_seats;
                        });
                    }
                })
                .catch((error) => {
                    this.$notify({
                        title: "Error",
                        text: error,
                        type: "error",
                    });
                    // this.$swal("Error", error.response.data.message, "error");
                })
                .then(() => {
                    this.loadingBuses = false;
                });
        },
        assignBus(item) {
            this.selectedDriver = item;
            this.busesDialog = true;
            this.loadAvailableBuses();
        },
        setStudentBus(item, is_morning) {
            this.selectedStudentMorning = is_morning;
            this.selectedStudent = item;
            this.busesForStudentDialog = true;
            this.loadAllBuses(is_morning);
        },
        closeStudentBusDialog() {
            this.busesForStudentDialog = false;
            this.loadingBuses = false;
            this.availableBuses = [];
        },
        closeBusDialog() {
            this.busesDialog = false;
            this.loadingBuses = false;
            this.availableBuses = [];
        },
        assignBusToStudent(bus) {
            this.loadingBuses = true;
            axios
                .post("/users/assign-student-bus", {
                    student_id: this.selectedStudent.id,
                    bus_id: bus.id,
                    is_morning: this.selectedStudentMorning,
                })
                .then((response) => {
                    console.log(response);
                    this.selectedStudent.student_settings = response.data.student_settings;
                    this.loadingBuses = false;
                    this.closeStudentBusDialog();
                    this.$notify({
                        title: "Success",
                        text: "Bus assigned to student",
                        type: "success",
                    });
                })
                .catch((error) => {
                    this.isSubmit = false;
                    this.$notify({
                        title: "Error",
                        text: error,
                        type: "error",
                    });
                    // this.$swal("Error", error.response.data.message, "error");
                })
                .then(() => {
                    this.closeStudentBusDialog();
                });
        },
        assignBusToDriver(bus) {
            this.loadingBuses = true;
            axios
                .post("/drivers/assign-bus", {
                    driver_id: this.selectedDriver.id,
                    bus_id: bus.id,
                })
                .then((response) => {
                    console.log(response);
                    this.loadingBuses = false;
                    this.selectedDriver.bus = bus;
                    console.log(this.selectedDriver);
                    this.closeBusDialog();
                    this.$notify({
                        title: "Success",
                        text: "Bus assigned to driver",
                        type: "success",
                    });
                })
                .catch((error) => {
                    this.isSubmit = false;
                    this.$notify({
                        title: "Error",
                        text: error,
                        type: "error",
                    });
                    // this.$swal("Error", error.response.data.message, "error");
                })
                .then(() => {
                    this.closeBusDialog();
                });
        },
        unAssignBus(item) {
            this.$swal
                .fire({
                    title: "Un-assign bus",
                    text:
                        "Are you sure to un-assign the driver ' " +
                        item.name +
                        " ' from the bus '" +
                        item.bus.license +
                        "' ? You won't be able to revert this!",
                    icon: "error",
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete it!",
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.unassignBusFromDriver(item);
                    }
                });
        },
        unassignBusFromDriver(driver) {
            this.isSubmit = true;
            axios
                .post("/drivers/unassign-bus", {
                    driver_id: driver.id,
                })
                .then((response) => {
                    this.isSubmit = false;
                    driver.bus = null;
                    this.$notify({
                        title: "Success",
                        text: "Bus unassigned from driver",
                        type: "success",
                    });
                })
                .catch((error) => {
                    this.isSubmit = false;
                    this.$notify({
                        title: "Error",
                        text: error,
                        type: "error",
                    });
                    // this.$swal("Error", error.response.data.message, "error");
                })
                .then(() => {
                    this.closeBusDialog();
                });
        },
        downloadTemplate() {
            this.isSubmit = true;
            axios
                .get("/users/download-template-for-" + this.userType, {
                    responseType: "blob",
                })
                .then((response) => {
                    this.isSubmit = false;
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", this.userType + "_template.xlsx");
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((error) => {
                    this.isSubmit = false;
                    this.$notify({
                        title: "Error",
                        text: error,
                        type: "error",
                    });
                    // this.$swal("Error", error.response.data.message, "error");
                });
        },

        openUploadFile() {
            this.$refs.file.value = "";
            this.$refs.file.click();
        },
        uploadTemplateFile(event) {
            const files = event.target.files
            let file = files[0]
            //get the selected file
            if (file) {
                this.isSubmit = true;
                let formData = new FormData();
                formData.append("file", file);
                axios
                    .post("/users/upload-" + this.userType, formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then((response) => {
                        this.isSubmit = false;
                        this.$notify({
                            title: "Success",
                            text: "File uploaded successfully",
                            type: "success",
                        });
                        this.loadUsers();
                    })
                    .catch((error) => {
                        this.isSubmit = false;
                        this.$notify({
                            title: "Error",
                            text: error,
                            type: "error",
                        });
                        // this.$swal("Error", error.response.data.message, "error");
                    });
            }

        },

    },
};
</script>
